// @flow strict
export const DefaultLayoutSymbol = Symbol('default');
export const UniformRowLayoutSymbol = Symbol('uniformRow');
